// eslint-disable-next-line import/no-anonymous-default-export
export default {
    Indefinida: 0,
    Recebida: 1,
    NaoRecebida: 2
}